require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 1114
// module chunks = 1